import PropTypes from 'prop-types'
import styles from './index.module.scss'
import TopicIcon from '~/components/shared/TopicIcon'
import Tooltip from '~/components/shared/Tooltip'
import { TopicPropType } from '~/utils/prop-types'
import { tField } from '~/utils/translations'
import ConditionalLink from '../ConditionalLink'

const Pill = ({
  topic, href, as, ...props
}) => (
  <ConditionalLink
    condition={!!as && !!href}
    href={href}
    as={as && encodeURI(as)}
    linkComponentProps={{
      onClick: e => e.stopPropagation(),
      ...props
    }}
    alternativeWrapper="span"
    {...props}
  >
    <TopicIcon topic={topic} />
    {' '}
    {tField(topic, 'name')}
  </ConditionalLink>
)

Pill.propTypes = {
  topic: TopicPropType.isRequired,
  href: PropTypes.string,
  as: PropTypes.string,
}

Pill.defaultProps = {
  href: '',
  as: '',
}

const TopicsPills = ({
  topics, className, pillPath, pillHref, ...props
}) => !!topics.length && (
  <div {...props} className={`d-flex flex-wrap ${styles.topicsPills} ${className}`}>
    {topics.slice(0, topics.length <= 3 ? topics.length : 2).map((topic) => (
      <Pill
        topic={topic}
        href={pillPath}
        as={pillHref?.(topic)}
        key={topic.id}
        className={styles.pill}
      />
    ))}
    {topics.length > 3 && (
    <Tooltip text={topics.slice(2).map(topic => <div key={topic.id}>{tField(topic, 'name')}</div>)}>
      <span className={styles.pill}>{`+${topics.length - 2}`}</span>
    </Tooltip>
    )}
  </div>
)

TopicsPills.propTypes = {
  topics: PropTypes.arrayOf(TopicPropType).isRequired,
  className: PropTypes.string,
  pillPath: PropTypes.string,
  pillHref: PropTypes.func,
}

TopicsPills.defaultProps = {
  className: '',
  pillPath: '',
  pillHref: null,
}

export default TopicsPills
